import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  icons: null,
  additionalDlbs: ['apollo-dlb/bundle.js'],
  logFetchErrors: {
    options: {
      ignoreErrors: []
    }
  },
  htmlTitle: 'Deal Plan',
  htmlTitleLangKey: 'app.htmlTitle',
  historyBasename: '/:basename',
  createRootApi: true,
  loadWhisperCore: false,
  initialPageLoadTracking: false,
  includeDefaultViewportMetaTag: true
});